import { Routes } from '@/router/routes'
import { RouterContexts } from '@/router/RouterContexts'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const mapsRoutes = [
  {
    path: '/maps',
    name: Routes.Maps,
    component: () => import('@/components/layout/MapsLayout.vue'),
    meta: {
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.FORCE_TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_MAPS,
      routerContexts: [RouterContexts.PORTAL_CONTEXT],
    },
  },
]
